(function () {
    'use strict';

    angular
        .module('app')
        .controller('ConcertContractController', ConcertContractController);

    ConcertContractController.$inject = ['$http', '$state', '$stateParams', '$scope', '$q', '$location', '$rootScope', '$cookies', 'dialog', 'cache', 'promoModule'];

    function ConcertContractController($http, $state, $stateParams, $scope, $q, $location, $rootScope, $cookies, dialog, cache, promoModule) {
        var vm = this;
        vm.$onInit = init;
        vm.close = close;
        vm.copyLink = copyLink;
        vm.confirmConcertContract = confirmConcertContract;
        vm.rejectConcertContract = rejectConcertContract;
        vm.lowFiBookingFeeInfo = lowFiBookingFeeInfo;
        vm.bookingTermsInfo = bookingTermsInfo;
        vm.contactCocreator = contactCocreator;


        function copyLink() {
            navigator.clipboard.writeText(vm.concert_link);
            vm.link_copied = 1;
        }

        function init() {
            window.document.title = $stateParams.language == 'da' ? "Koncert aftale - Be My Concert" : "Concert agreement - Be My Concert";
            vm.concert_slug = $stateParams.concert_slug;
            vm.loaded = false;
            getConcertContractDetails();
            vm.state = "unconfirmed";
            getConcert();
        }

        function getConcert() { //Get data about the concert with the concert-API
            return $http.get('api/concerts/' + $stateParams.concert_slug + '/')
                .then(function (response) {
                    vm.concert = response.data;
                    vm.concert_link = response.data.concert_link;
                    vm.concert_link_da = response.data.concert_link_da;
                    if($stateParams.language == 'da'){
                        vm.mailto_link = "mailto:" + "" +
                                    "?subject=" + vm.concert.concert_name + " - Be My Concert" +
                                    "&body=" + vm.concert_link_da;
                    } else if ($stateParams.language == 'en') {
                        vm.mailto_link = "mailto:" + "" +
                                    "?subject=" + vm.concert.concert_name + " - Be My Concert" +
                                    "&body=" + vm.concert_link;
                    }


                    if (vm.concert.concert_deleted_at > '') {
                        return $state.go('item_deleted');
                    }

                });
        }

        function getConcertContractDetails() {
            return $http.get('api/concert/contract/' + vm.concert_slug + '/')
                .then(function (response) {
                     vm.loaded = true;
                    vm.details = response.data;
                    vm.is_creator = response.data.is_creator;
                    vm.creator_is_host = response.data.creator_is_host;
                    vm.creator_is_artist = response.data.creator_is_artist;
                    vm.show_contract = vm.details.concert_published != null && vm.details.concert_pending == null && vm.details.concert_rejected == null;
                    vm.concert_unconfirmed = vm.details.concert_published == null && vm.details.concert_pending == null && vm.details.concert_rejected == null;
                    vm.concert_pending = vm.details.concert_pending != null;

                    if(vm.is_creator && vm.details.concert_pending != null) {
                        vm.confirmed = true;
                    }
                    if(vm.details.concert_rejected) {
                        vm.rejected = true;
                    }
                    if( vm.creator_is_host && vm.creator_is_artist) {
                        if(vm.details.concert_published == null) {
                            vm.loaded = false;
                            $http.post('api/concert/contract/' + vm.concert_slug + '/confirm')
                            .then(function (response) {
                                vm.loaded = true;
                                vm.confirmed = true;
                                vm.is_creator = false;
                                cache.clear();
                                promoModule.createAllBanners(vm.concert, { concert_slug: vm.concert_slug });
                            }).catch(function() {
                                vm.error = true;
                            });
                        } else {
                            vm.show_contract = true;
                        }
                    }
                });
        }

        function confirmConcertContract() {
            vm.await = true;
            $http.post('api/concert/contract/' + vm.concert_slug + '/confirm')
                .then(function (response) {
                    vm.confirmed = true;
                    vm.await = false;
                    promoModule.createAllBanners(vm.concert, { concert_slug: vm.concert_slug });
                }).catch(function() {
                    vm.error = true;
                    vm.await = false;
                });
        }

        function rejectConcertContract() {
            vm.await = true;
            $http.post('api/concert/contract/' + vm.concert_slug + '/reject')
                .then(function (response) {
                    vm.rejected = true;
                    vm.await = false;
                }).catch(function() {
                    vm.error = true;
                    vm.await = false;
                });
        }

      /*   $scope.$on("$destroy", function(event) {
            if(!vm.confirmed) {
                event.preventDefault();
                dialog.prompt('unsaved-changes-prompt', function (response) {
                    if (response.confirm) {
                        return $state.go('member');
                    }
                });
            }
        }); */

        function close() {
            if(vm.concert_unconfirmed && !vm.confirmed) {
                dialog.prompt('accept-before-closing-prompt', function (response) {
                    if (response.alternative) {
                        $state.go('edit_concert', {concert_slug: vm.concert_slug })
                    }
                }, 'close', true);
            } else if(vm.confirmed && vm.is_creator) {
                $state.go('member');
            } else {
                cache.clear();
                history.back();
            }
        }

        function bookingTermsInfo() {
            dialog.info('booking-terms-info');
        }

        function lowFiBookingFeeInfo() {
            dialog.info('low-fi-booking-fee-info');
        }

        function contactCocreator() {
            if(vm.creator_is_host) {
                $state.go('host', {space_slug: vm.details.space_slug});
            }
            if(vm.creator_is_artist) {
                $state.go('musician', {space_slug: vm.details.band_slug});
            }

        }
    }
})();
